class FilterJobOffers {
	constructor() {
		const filter = document.querySelector("#filterSubsidiaries");
		const jobOfferContainer = document.querySelector(".job-offers");
		const jobOffers = document.querySelectorAll(".job-offers .job-offer");
		if (filter) {
			filter.addEventListener("change", () => {
				gsap.to(jobOfferContainer, {
					opacity: 0,
					onComplete: () => {
						if (filter.value === "all") {
							gsap.set(jobOffers, {
								display: "flex"
							});
						} else {
							gsap.set(jobOffers, {
								display: "none"
							});
							const toDisplay = document.querySelectorAll(`.job-offer[data-subsidiary="${filter.value}"]`);
							gsap.set(toDisplay, {
								display: "flex"
							});
						}
						gsap.to(jobOfferContainer, {
							opacity: 1,
						});
						ScrollTrigger.refresh();
					}
				});
			});
		}
	}
}
